import {
  StyleParamType,
  wixColorParam,
  wixFontParam,
  createStylesParams,
} from '@wix/tpa-settings';

export type IStylesParams = {
  widgetWidth: StyleParamType.Number;
  widgetHeight: StyleParamType.Number;
  bottomSidePadding: StyleParamType.Number;
  productImageAspectRatio: StyleParamType.Number;

  headerBackground: StyleParamType.Color;
  headerFont: StyleParamType.Font;
  headerTextColor: StyleParamType.Color;
  minimizeIconColor: StyleParamType.Color;
  avatarColor: StyleParamType.Color;
  widgetTopLeftRadius: StyleParamType.Number;
  widgetTopRightRadius: StyleParamType.Number;
  widgetBottomLeftRadius: StyleParamType.Number;
  widgetBottomRightRadius: StyleParamType.Number;

  mainBackground: StyleParamType.Color;
  shadowColor: StyleParamType.Color;
  shadowBlur: StyleParamType.Number;
  shadowSpread: StyleParamType.Number;
  shadowDirection: StyleParamType.Number;

  messagesVisitorMessageColor: StyleParamType.Color;
  messagesVisitorMessageFont: StyleParamType.Font;
  messagesVisitorMessageBackground: StyleParamType.Color;
  messagesVisitorMessageBorderColor: StyleParamType.Color;
  messagesVisitorMessageBorderWidth: StyleParamType.Number;
  messagesVisitorMessageBorderRadius: StyleParamType.Number;
  messagesVisitorMessageLinkColor: StyleParamType.Color;

  messagesVisitorMessageShadowColor: StyleParamType.Color;
  messagesVisitorMessageShadowBlur: StyleParamType.Number;
  messagesVisitorMessageShadowSpread: StyleParamType.Number;
  messagesVisitorMessageShadowDirection: StyleParamType.Number;

  messagesAssistantMessageColor: StyleParamType.Color;
  messagesAssistantMessageFont: StyleParamType.Font;
  messagesAssistantMessageBackground: StyleParamType.Color;
  messagesAssistantMessageBorderColor: StyleParamType.Color;
  messagesAssistantMessageBorderWidth: StyleParamType.Number;
  messagesAssistantMessageBorderRadius: StyleParamType.Number;
  messagesAssistantMessageLinkColor: StyleParamType.Color;

  messagesAssistantMessageShadowColor: StyleParamType.Color;
  messagesAssistantMessageShadowBlur: StyleParamType.Number;
  messagesAssistantMessageShadowSpread: StyleParamType.Number;
  messagesAssistantMessageShadowDirection: StyleParamType.Number;

  // Widget Settings > Messages > Card > Button
  messagesButtonBackground: StyleParamType.Color;
  messagesButtonBorderRadius: StyleParamType.Number;
  messagesButtonBorderColor: StyleParamType.Color;
  messagesButtonFont: StyleParamType.Font;
  messagesButtonColor: StyleParamType.Color;

  // Widget Settings > AI Messages > Primary Button
  messagesButtonPrimaryBackground: StyleParamType.Color;
  messagesButtonPrimaryBorderRadius: StyleParamType.Number;
  messagesButtonPrimaryBorderColor: StyleParamType.Color;
  messagesButtonPrimaryFont: StyleParamType.Font;
  messagesButtonPrimaryColor: StyleParamType.Color;

  // Widget Settings > AI Messages > Secondary Button
  messagesButtonSecondaryBackground: StyleParamType.Color;
  messagesButtonSecondaryBorderRadius: StyleParamType.Number;
  messagesButtonSecondaryBorderColor: StyleParamType.Color;
  messagesButtonSecondaryFont: StyleParamType.Font;
  messagesButtonSecondaryColor: StyleParamType.Color;

  messagesCardBackground: StyleParamType.Color;
  messagesCardBorderColor: StyleParamType.Color;
  messagesCardBorderWidth: StyleParamType.Number;
  messagesCardBorderRadius: StyleParamType.Number;
  messagesCardTitleFont: StyleParamType.Font;
  messagesCardTitleColor: StyleParamType.Color;
  messagesCardDescriptionFont: StyleParamType.Font;
  messagesCardDescriptionColor: StyleParamType.Color;

  inputDefaultBackground: StyleParamType.Color;
  inputHoverBackground: StyleParamType.Color;
  inputFocusBackground: StyleParamType.Color;

  inputDefaultBorderColor: StyleParamType.Color;
  inputHoverBorderColor: StyleParamType.Color;
  inputFocusBorderColor: StyleParamType.Color;

  inputDefaultBorderSize: StyleParamType.Number;
  inputHoverBorderSize: StyleParamType.Number;
  inputFocusBorderSize: StyleParamType.Number;

  inputDefaultBorderRadius: StyleParamType.Number;
  inputHoverBorderRadius: StyleParamType.Number;
  inputFocusBorderRadius: StyleParamType.Number;

  inputTextFont: StyleParamType.Font;
  inputTextColor: StyleParamType.Color;
  inputPlaceholderColor: StyleParamType.Color;
  inputIconColor: StyleParamType.Color;

  minimizedButtonBackground: StyleParamType.Color;
  minimizedButtonRadius: StyleParamType.Number;
  minimizedButtonFont: StyleParamType.Font;
  minimizedButtonFontColor: StyleParamType.Color;
  minimizedButtonIconColor: StyleParamType.Color;

  minimizedButtonShadowColor: StyleParamType.Color;
  minimizedButtonShadowBlur: StyleParamType.Number;
  minimizedButtonShadowSpread: StyleParamType.Number;
  minimizedButtonShadowDirection: StyleParamType.Number;

  minimizedButtonAnimatedBorderWidth: StyleParamType.Number;
  minimizedButtonAnimatedBorderColor: StyleParamType.Color;

  // TODO: what it for POC only?
  backgroundColor: StyleParamType.Color;
  textFont: StyleParamType.Font;
  textColor: StyleParamType.Color;

  bubbleNotificationBackground: StyleParamType.Color;
  bubbleNotificationBorderWidth: StyleParamType.Number;
  bubbleNotificationBorderColor: StyleParamType.Color;
  bubbleNotificationRadius: StyleParamType.Number;
  bubbleNotificationFont: StyleParamType.Font;
  bubbleNotificationFontColor: StyleParamType.Color;

  bubbleNotificationShadowColor: StyleParamType.Color;
  bubbleNotificationShadowBlur: StyleParamType.Number;
  bubbleNotificationShadowSpread: StyleParamType.Number;
  bubbleNotificationShadowDirection: StyleParamType.Number;

  formBackground: StyleParamType.Color;
  formBorderColor: StyleParamType.Color;
  formBorderWidth: StyleParamType.Number;
  formRadius: StyleParamType.Number;

  formInputBorderColor: StyleParamType.Color;
  formInputErrorColor: StyleParamType.Color;
  formInputRadius: StyleParamType.Number;
  formLabelFont: StyleParamType.Font;
  formLabelFontColor: StyleParamType.Color;
  formInputFont: StyleParamType.Font;
  formInputFontColor: StyleParamType.Color;

  formButtonBackground: StyleParamType.Color;
  formButtonBorderColor: StyleParamType.Color;
  formButtonRadius: StyleParamType.Number;
  formButtonBorderWidth: StyleParamType.Number;
  formButtonFont: StyleParamType.Font;
  formButtonFontColor: StyleParamType.Color;
};

export enum WidgetWidthConstrains {
  Min = 400,
  Max = 600,
}

export enum WidgetHeightConstrains {
  Min = 60,
  Max = 100,
}

export enum WidgetPaddingConstrains {
  Min = 10,
  Max = 24,
}

const styleParams = createStylesParams<IStylesParams>({
  widgetWidth: {
    type: StyleParamType.Number,
    getDefaultValue: ({ isRTL, isEditorX, dimensions }) => {
      return 480;
    },
  },
  widgetHeight: {
    type: StyleParamType.Number,
    getDefaultValue: ({ isRTL, isEditorX, dimensions }) => {
      return 80;
    },
  },
  bottomSidePadding: {
    type: StyleParamType.Number,
    getDefaultValue: () => 10,
  },
  productImageAspectRatio: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  backgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-3'),
  },
  textFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 20,
    }),
  },
  textColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  headerBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  headerFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Page-title', {
      size: 16,
    }),
  },
  headerTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  minimizeIconColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  avatarColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  widgetTopLeftRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  widgetTopRightRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  widgetBottomLeftRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  widgetBottomRightRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  mainBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2'),
  },
  shadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('black', 0.08),
  },
  shadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: () => 30,
  },
  shadowSpread: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  shadowDirection: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  messagesVisitorMessageColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  messagesVisitorMessageFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 16 }),
  },
  messagesVisitorMessageBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  messagesVisitorMessageBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.2),
  },
  messagesVisitorMessageBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  messagesVisitorMessageBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  messagesVisitorMessageLinkColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  messagesVisitorMessageShadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(
        styleParams.messagesAssistantMessageShadowColor,
      );
      return value ?? wixColorParam('color-5', 0.12);
    },
  },
  messagesVisitorMessageShadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(
        styleParams.messagesAssistantMessageShadowBlur,
      );
      return value ?? 8;
    },
  },
  messagesVisitorMessageShadowSpread: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(
        styleParams.messagesAssistantMessageShadowSpread,
      );
      return value ?? 0;
    },
  },
  messagesVisitorMessageShadowDirection: {
    type: StyleParamType.Number,
    getDefaultValue: ({ getStyleParamValue }) => {
      const value = getStyleParamValue(
        styleParams.messagesAssistantMessageShadowDirection,
      );
      return value ?? 315;
    },
  },
  messagesAssistantMessageColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  messagesAssistantMessageFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 16 }),
  },
  messagesAssistantMessageBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  messagesAssistantMessageBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0),
  },
  messagesAssistantMessageBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  messagesAssistantMessageBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 16,
  },
  messagesAssistantMessageLinkColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  messagesAssistantMessageShadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.12),
  },
  messagesAssistantMessageShadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: () => 8,
  },
  messagesAssistantMessageShadowSpread: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  messagesAssistantMessageShadowDirection: {
    type: StyleParamType.Number,
    getDefaultValue: () => 315,
  },

  // CARD MESSAGES BUTTON
  messagesButtonBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  messagesButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  messagesButtonBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 4,
  },
  messagesButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 16 }),
  },
  messagesButtonColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },

  // AI MESSAGES PRIMARY BUTTON
  messagesButtonPrimaryBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-fill-primary'),
  },
  messagesButtonPrimaryBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-border-primary'),
  },
  messagesButtonPrimaryBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 40,
  },
  messagesButtonPrimaryFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 14 }),
  },
  messagesButtonPrimaryColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-text-primary'),
  },

  // AI MESSAGES SECONDARY BUTTON
  messagesButtonSecondaryBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-fill-secondary'),
  },
  messagesButtonSecondaryBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-border-secondary'),
  },
  messagesButtonSecondaryBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 40,
  },
  messagesButtonSecondaryFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 14 }),
  },
  messagesButtonSecondaryColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-text-secondary'),
  },

  // MESSAGES CARD
  messagesCardBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  messagesCardBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.2),
  },
  messagesCardBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  messagesCardBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 8,
  },
  messagesCardTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      style: { bold: false, italic: false, underline: false },
    }),
  },
  messagesCardTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  messagesCardDescriptionFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 16 }),
  },
  messagesCardDescriptionColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },

  inputDefaultBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  inputHoverBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  inputFocusBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  inputDefaultBorderSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  inputHoverBorderSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  inputFocusBorderSize: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  inputDefaultBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 40,
  },
  inputHoverBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 40,
  },
  inputFocusBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 40,
  },
  inputTextFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 16 }),
  },
  inputTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  inputPlaceholderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-3'),
  },
  inputIconColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  inputDefaultBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.6),
  },
  inputHoverBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
  },
  inputFocusBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  minimizedButtonBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8'),
  },
  minimizedButtonRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 40,
  },
  minimizedButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 16 }),
  },
  minimizedButtonFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2'),
  },
  minimizedButtonIconColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
  },
  minimizedButtonShadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.4),
  },

  minimizedButtonShadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: () => 8,
  },
  minimizedButtonShadowSpread: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  minimizedButtonShadowDirection: {
    type: StyleParamType.Number,
    getDefaultValue: () => 2,
  },
  bubbleNotificationBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-fill-background-primary'),
  },
  bubbleNotificationBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  bubbleNotificationBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-line', 0.2),
  },
  bubbleNotificationRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 8,
  },
  bubbleNotificationFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 16 }),
  },
  bubbleNotificationFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-title'),
  },
  bubbleNotificationShadowColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.1),
  },
  bubbleNotificationShadowBlur: {
    type: StyleParamType.Number,
    getDefaultValue: () => 4,
  },
  bubbleNotificationShadowSpread: {
    type: StyleParamType.Number,
    getDefaultValue: () => 2,
  },
  bubbleNotificationShadowDirection: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  formBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-fill-background-primary'),
  },
  formBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-line', 0.2),
  },
  formBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  formRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 8,
  },
  formInputBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-line', 0.6),
  },
  formInputErrorColor: {
    type: StyleParamType.Color,
    getDefaultValue: () => ({
      value: '#df3131',
      name: null,
      opacity: 1,
    }),
  },
  formInputRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 4,
  },
  formLabelFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 14 }),
  },
  formLabelFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-title'),
  },
  formInputFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 14 }),
  },
  formInputFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-title'),
  },
  formButtonBackground: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-fill-primary'),
  },
  formButtonBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-border-primary'),
  },
  formButtonBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  formButtonRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 4,
  },
  formButtonFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { size: 16 }),
  },
  formButtonFontColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('button-color-text-primary'),
  },
  minimizedButtonAnimatedBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 2,
  },
  minimizedButtonAnimatedBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-2'),
  },
});

export default styleParams;
